<template>
    <div>
        <a @click="hideMakeOffer">ⅹ CANCEL</a>
        <b-field label="Messenger m.me link" message="This is where borrowers contact you if they're interested in your offer" v-if="mme_link_missing">
            <b-input v-model="request.mme_link" required></b-input>
        </b-field>
        <b-field label="Loan Amount">
            <b-input v-model="request.amount" required></b-input>
        </b-field>
        <b-field label="Total Interest">
            <b-input v-model="request.interest" required></b-input>
        </b-field>
        <b-button type="is-primary"
                  :disabled="request.mme_link === null && mme_link_missing === true"
                  @click="makeOffer">
            Send Offer to Borrower
        </b-button>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import bus from '../bus'
    export default {
        name: "MakeOffer",
        components: {BButton},
        props: ['loan'],
        data() {
            return {
                mme_link_missing: false,
                request: {
                    loan_ref: null,
                    amount: null,
                    interest: null,
                    mme_link: null
                }
            }
        },
        mounted() {
            const vm = this;
            vm.request.loan_ref = vm.$props.loan._id;
            vm.request.amount = vm.$props.loan.principal;
            vm.request.interest = vm.$props.loan.interest;
            if (localStorage.getItem('mme_link')) {
                vm.request.mme_link = localStorage.getItem('mme_link')
            } else {
                vm.mme_link_missing = true
            }
        },
        methods: {
            hideMakeOffer() {
                bus.$emit('hide')
            },
            makeOffer() {
                var request = this.request
                request.amount = this.request.amount.toString();
                request.interest = this.request.interest.toString();
                this.axios.post(this.$host + '/offerLend/', request)
                    .then(function (res) {
                        alert("Offer sent!");
                    })
                    .catch(function (err) {
                        alert(err);
                    })
            }
        }
    }
</script>

<style scoped>

</style>